import * as React from "react"
import Svg, { Path } from "react-native-svg"

const AccountSettingsIcon = (props) => (
    <Svg
        width={29}
        height={29}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M25.919 11.781c-1.45.181-2.81-.453-3.625-1.812-.725-1.269-.635-2.9.272-3.988-1.36-1.268-2.991-2.175-4.713-2.718-.544 1.268-1.812 2.175-3.353 2.175-1.54 0-2.81-.907-3.353-2.266-1.813.544-3.444 1.45-4.713 2.719.816 1.178.997 2.809.182 4.078A3.681 3.681 0 0 1 2.99 11.78c-.182.906-.363 1.813-.363 2.719 0 .906.09 1.903.363 2.719 1.45-.181 2.809.453 3.625 1.812.725 1.269.634 2.9-.272 3.988 1.36 1.269 2.99 2.175 4.712 2.719.544-1.27 1.813-2.266 3.353-2.266 1.541 0 2.81.906 3.353 2.265 1.813-.543 3.444-1.45 4.713-2.718-.816-1.088-.997-2.719-.272-3.988a3.681 3.681 0 0 1 3.625-1.812c.181-.907.363-1.813.363-2.719.09-.906 0-1.903-.272-2.719Z"
            stroke="#242424"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path
            d="M14.5 17.219a2.719 2.719 0 1 0 0-5.438 2.719 2.719 0 0 0 0 5.438Z"
            stroke="#242424"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
)

export default AccountSettingsIcon
